// eslint-disable-next-line
import util from 'util';

import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import * as MuiCore from '@material-ui/core';
import { Route, withRouter } from 'react-router-dom'

import Login from './Login';
import Payments from './Payments';
import * as PortalApi from './PortalApi';
import * as PortalActions from './PortalActions';
import { Cookies } from 'react-cookie';

/*
 * Main control component of the site
 */

const styles = theme => ({
  root : {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundImage: 'linear-gradient(135deg, white, ' +  
                     theme.palette.primary.light + ')',
    display : 'flex',
    flexDirection : 'column',
    alignItems: 'center',
    overflow : 'auto',
  },
  menuIconButton : {
    color: theme.palette.primary.contrastText,
  },
  appLogo : {
    ...theme.typography.h6,
    marginLeft: '2%',
    marginRight: '5%',
  },
  toolBar : {
    display: 'flex',
  },
  userName : {
    ...theme.typography.h6,
    marginRight: '2%',
  },
  contentPanel : {
    flexShrink: 1,
    margin: '3%',
    padding: 20,
    borderRadius: 10,
    maxWidth: '800px',
  },
});

class Home extends React.Component {
  initialState = {
    drawerOpen: false,
    webUser : {},
    initialLoad: false,
    confirmLogout : false,
    cdnScript: "",
  };

  sessionKey = undefined;
  identityKey = undefined;
  transferAccountId = undefined;
  constructor(props) {
    super(props);
    this.state = { ...this.initialState, initialLoad: true};

  }
  

  apiErrorHandler = (status, content) => {
  }

  /* 
   * This is called whenever an API call gets an 
   * unauthorized response
   */
  apiUnauthorizedHandler = (status, content, retry) => {
    /* 401 with no session key only happens when trying to create a
       session key.  It means the identity key is no longer good so remove it 
       and reset the session. */  
    if (!Boolean(this.sessionKey)) {
      localStorage.removeItem("identityKey");
      this.sessionKey = undefined;
      this.identityKey = undefined;
      this.setState({...this.initialState});
      return;
    }

    /* Clear out the session key */
    this.sessionKey = undefined;
    localStorage.removeItem("sessionKey");
    
    /* Try to make a new session and retry the call if there is an identity key */
    this.identityKey = localStorage.getItem("identityKey");
    if (this.identityKey) {
      PortalActions.createSession(this.identityKey, (session) => {
        localStorage.setItem("sessionKey", session.sessionKey);
        this.sessionKey = session.sessionKey;
        PortalActions.queryWebUser((webUser) => this.setState({webUser}));
        if (typeof(retry) === 'function') {
          retry();
        }
      });
      return;
    }

    /* Go to initial state if no other options */
    this.setState({...this.initialState});
  }

  /* 
   * A new login has completed 
   */
  loginComplete = (identityKey, sessionKey, saveIdentity) => {
    /* Only put the identity key in storage if they checked
       the stay logged in box */
    if (saveIdentity) {
      localStorage.setItem("identityKey", identityKey);
    }  else {
      localStorage.removeItem("identityKey");
    }
    localStorage.setItem("sessionKey", sessionKey);
    this.identityKey = identityKey;
    this.sessionKey = sessionKey;
    PortalActions.queryWebUser((webUser) => this.setState({webUser}));    
  }


  /* Called if they select logout from the menu */
  logout = () => {
    PortalActions.endSession((status) => {
      this.identityKey = undefined;
      this.sessionKey = undefined;
      localStorage.removeItem("identityKey");
      localStorage.removeItem("sessionKey");
      this.setState({...this.initialState});
    });
    
  }

  /*
   * Setup the API and try to restore the credentials on startup
   */
  componentDidMount() {
    /* Provide the functions to the API */
    PortalApi.setup(() => (this.sessionKey), this.apiErrorHandler, this.apiUnauthorizedHandler);

    //= Cookies.get("transferAccountId");
    this.transferAccountId = document.cookie.replace(/(?:(?:^|.*;\s*)transferAccountId\s*\=\s*([^;]*).*$)|^.*$/, "$1");

    /* Fetch the public key for Stripe */
    PortalActions.queryStripePublicKey((apiKey) => {
      this.setState({apiKey});
    });

    /* Fetch the default payment processor Id. */
    PortalActions.queryStripeProcessorId((paymentProcessorId) => {
      this.setState({paymentProcessorId});
    });

    /* Fetch any CDN Scripts */
    PortalActions.queryPortalCDNScripts((cdnScript) => {
      this.setState({cdnScript});
    });

    /* If the script doesn't already exist, add it to the <HEAD> */
    if (this.state.cdnScript != null) {
      let elementExists = document.getElementById("ZohoCDNScript-PTN")
      if (elementExists) {
        elementExists.remove();
      }
      //Append it to head
      const pageScript = document.createElement("script");
      pageScript.id = "ZohoCDNScript-PTN";
      pageScript.type = "text/javascript";
      pageScript.async = true;

      pageScript.setAttribute("src", this.state.cdnScript);
      // pageScript.innerText = this.state.cdnScript;
      //pageScript.setAttribute("src", this.state.cdnScript);
      document.head.appendChild(pageScript);
    }

    /* If the transfer identity is set, we just been linked from the
       old portal so use that for our ID and clear out any login */
    if (this.props.transferIdentity) {
      this.identityKey = this.props.transferIdentity;
      localStorage.removeItem("identityKey");
      localStorage.removeItem("sessionKey");
    } else {
      this.sessionKey = localStorage.getItem("sessionKey");
      this.identityKey = localStorage.getItem("identityKey");
    }

    /* Using the router is for future expansion and adding more page. */
    if (this.props.history.location.pathname === '/') {
      this.props.history.replace('/payments');
    }

    /* If there is a session key in storage, run the user fetch to see
       if it works.  If it doesn't the apiUnauthorizedHandler will
       get called */  
    if (Boolean(this.sessionKey)) {
      PortalActions.queryWebUser((webUser) => this.setState({webUser}));
      return;
    }


    /* No session key but an identity key, try to use it to make a new
       session.  */
    if (Boolean(this.identityKey)) {
      PortalActions.createSession(this.identityKey, (session) => {
        localStorage.setItem("sessionKey", session.sessionKey);
        this.sessionKey = session.sessionKey;
        PortalActions.queryWebUser((webUser) => this.setState({webUser}));
      });
      return;
    }

    /* Nothing stored so just turn off initial load so the login dialog
       pops up */
    this.setState({initialLoad: false});    
  }

  componentDidUpdate() {
    if (this.state.initialLoad && !Boolean(this.identityKey)) {
      this.setState({initialLoad: false});
    }
  }
  

  render() {
    const { classes } = this.props;
    const { initialLoad } = this.state;

    return (
      <div className={classes.root}>
        <Login onLogin={this.loginComplete}
               open={!Boolean(this.sessionKey) && !initialLoad}/>
        <MuiCore.Dialog open={this.state.confirmLogout}>
          <MuiCore.DialogTitle>Logout</MuiCore.DialogTitle>
          <MuiCore.DialogContent>
            <MuiCore.DialogContentText>
              Are you sure you want to logout?
            </MuiCore.DialogContentText>
          </MuiCore.DialogContent>
          <MuiCore.DialogActions>
            <MuiCore.Button onClick={() => this.setState({confirmLogout: false})}>Cancel</MuiCore.Button>
            <MuiCore.Button onClick={this.logout}>Logout</MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>
        
        <MuiCore.Hidden xlDown={!Boolean(this.sessionKey) || !Boolean(this.state.apiKey)}>
          <Route path="/payments">
            <Payments webUser={this.state.webUser}
                      apiKey={this.state.apiKey}
                      paymentProcessorId={this.state.paymentProcessorId}
                      transferAccountId={this.transferAccountId}
                      sessionKey={this.props.sessionKey}
                      cdnScript={this.state.cdnScript}
                      onLogout={() => this.setState({confirmLogout: true})}/>
          </Route>
        </MuiCore.Hidden>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(Home));

